/** One organisation's gunshot counts over the three time ranges the backoffice reports, plus its live scouts. */
export interface GunshotStatisticsForTimeRanges {
  organisationId: string;
  organisationName: string;
  userId: string;
  lastHourCount: number;
  last24HoursCount: number;
  lastWeekCount: number;
  activeScouts: number;
}

/** Most active first: last hour, then last 24 hours, then last week, then live scouts. */
export const sortByActivity = (statistics: GunshotStatisticsForTimeRanges[]) =>
  [...statistics].sort(
    (a, b) =>
      b.lastHourCount - a.lastHourCount ||
      b.last24HoursCount - a.last24HoursCount ||
      b.lastWeekCount - a.lastWeekCount ||
      b.activeScouts - a.activeScouts
  );

export interface ListeningSummary {
  scouts: number;
  organisations: number;
}

/** Live scouts across all organisations, and how many organisations have at least one. */
export const summarizeListening = (statistics: GunshotStatisticsForTimeRanges[]): ListeningSummary => ({
  scouts: statistics.reduce((sum, s) => sum + s.activeScouts, 0),
  organisations: statistics.filter((s) => s.activeScouts > 0).length,
});
